import Cross from '@assets/icons/cross.svg'
import { Icon } from './Icon'

export const CrossIcon = Icon(Cross)
